<script setup>
import {onMounted, ref} from "vue";
import axios from "axios";
import {axiosCatchHandler} from "../../modules/sharedGlobal";
import SweetToast from "../../SweetToast";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";

const showBanner = ref(false);
const bannerData = ref({});

const handleAddSecondWebsite = async () => {
  try {
    const {data} = await axios.post('/ajax/websites/promotional-banner/store');

    window.location.href = data.redirectUrl;
  } catch (error) {
    axiosCatchHandler(error, () => {});

    if (error.response.status === 400) {
      showBanner.value = false;

      SweetToast.fire({
        icon: 'error',
        title: error.response.data.message ?? 'Something went wrong',
      });
    }
  }
}

onMounted(async () => {
  try {
    const {data} = await axios.get('/ajax/websites/promotional-banner');
    showBanner.value = data.showBanner;
    bannerData.value = data.bannerData;
  } catch (error) {
    axiosCatchHandler(error, () => {});
  }
});
</script>

<template>
  <div
    v-if="showBanner"
    class="tw-w-full tw-bg-teal-highlight tw-border tw-border-teal tw-rounded-lg tw-flex tw-items-center tw-justify-between tw-gap-4"
  >
    <div class="tw-flex tw-items-stretch tw-self-stretch">
      <div class="tw-flex tw-items-center tw-justify-center tw-p-5 tw-bg-teal">
        <p class="tw-text-white tw-uppercase tw-text-2xl tw-font-medium">
          Exclusive <br>offer
        </p>
      </div>
      <span
        id="triangle"
        class="tw-flex tw-h-auto tw-w-10 tw-bg-teal"
      />
    </div>

    <div class="tw-flex tw-flex-col tw-gap-2">
      <span class="tw-font-bold tw-text-slate-100 tw-text-base lg:tw-text-2xl">
        Add your second website today for only
        <span class="tw-text-everest">
          <span class="tw-line-through tw-text-red">{{ bannerData.currency }}{{ bannerData.originalPrice }}</span>
          {{ bannerData.currency }}{{ bannerData.newPrice }} a month, for life!
        </span>
      </span>

      <span class="tw-text-base lg:tw-text-xl tw-text-slate-200">
        <span class="tw-font-bold">
          Save {{ bannerData.savingPercentage }}%
        </span>
        and improve the SEO for another client website. Available for a limited time only.
      </span>
    </div>

    <div class="tw-mr-6">
      <DefaultButton
        variant="everest"
        @click="handleAddSecondWebsite"
      >
        Add Second Website
      </DefaultButton>
    </div>
  </div>
</template>

<style scoped>
#triangle {
  clip-path: polygon(0 0, 100% 0, 0 100%);
}
</style>
